// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"677":"1ec639df","701":"f686b94c","879":"32af437e","891":"600a35bb"}[chunkId] + ".chunk.js";
};